import {cloneDeep, get} from 'lodash';
import {getBoolean, getNumber, getString} from 'Core/helpers/data';
import {ManageDocumentsListItemDataObject} from "../dataObjects";
import {getDate, STANDARD_DATE_TIME_FORMAT} from "Core/helpers/datetime";
import * as languageDataMap from 'Language/dataMap';

/**
 * Get input data from raw data
 * @param {Object} rawData - Raw data received from IO.
 * @return {ManageDocumentsListItemDataObject}
 */
export const input = rawData => {
	let result = cloneDeep(rawData);

	result = new ManageDocumentsListItemDataObject(
		getString(result, 'id'),
		getString(result, 'title'),
		getBoolean(result, 'linkFlag'),
		getString(result, 'link', null, true),
		(get(result, 'releaseDate', null) ? 
			getDate(result.releaseDate, STANDARD_DATE_TIME_FORMAT.ISO_DATE_TIME_S) : 
			null
		),
		languageDataMap.input(get(result, 'languageData')),
		getNumber(result, 'ordinal', 1)
	);

	return result;
}

// @note: There is no output function since list is read-only.